"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domReady = void 0;
function domReady(fn) {
    function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        fn();
    }
    if (document.readyState === 'loading') {
        document.addEventListener && document.addEventListener('DOMContentLoaded', onReady);
    }
    else {
        fn();
    }
}
exports.domReady = domReady;
